export const translations = {
  it: {
    floating: "Chiama e prenota",
    nav: {
      home: "Home",
      about: "Chi Siamo",
      menu: "Menu",
      contact: "Contatti",
      book: "Prenota",
    },
    hero: {
      eyebrow: "Ristorante · Pizzeria · Forno a Legna",
      place: "Castelnuovo del Garda — Lago di Garda",
      name: "Gunè",
      tagline: "L'arte del fuoco, l'anima della tavola.",
      sub: "Cucina mediterranea di carne e pesce, pizza cotta a fiamma viva nel grande salotto elegante sulla strada per il Lago di Garda.",
      ctaBook: "Prenota un tavolo",
      ctaMenu: "Scopri il menu",
      ratingLine: "4,3 · 3.360 recensioni su Google",
      scroll: "Scorri",
    },
    marquee: [
      "Forno a Legna",
      "Alta Gastronomia",
      "Castelnuovo del Garda",
      "Selezione Vini",
      "Pizza Gourmet",
      "Ospitalità",
    ],
    highlights: {
      eyebrow: "I punti di forza",
      title: "Il piacere della tavola,\nin ogni dettaglio",
      intro:
        "I motivi per cui i nostri ospiti tornano: la fiamma che non si spegne, la materia prima del territorio e un salotto che accoglie.",
      cards: [
        {
          n: "01",
          img: "/img/pizza.webp",
          title: "Pizza gourmet al forno a legna",
          text: "Lievito a lunga maturazione, cornicione arioso e ingredienti scelti: la nostra pizza nasce da una fiamma viva che non si spegne mai.",
        },
        {
          n: "02",
          img: "/img/pesce.webp",
          title: "Cucina mediterranea di carne e pesce",
          text: "Dalla tradizione veneta ai sapori del Garda: piatti di carne e pesce, opzioni vegane e materia prima fresca ogni giorno.",
        },
        {
          n: "03",
          img: "/img/tagliere.webp",
          title: "Antipasti & salumi",
          text: "Taglieri ricchi di salumi e formaggi, fritti della casa e bruschette: il modo migliore di iniziare a tavola.",
        },
        {
          n: "04",
          img: "/img/insalata.webp",
          title: "Insalate & piatti freschi",
          text: "Proposte leggere e genuine con ingredienti croccanti di stagione: il gusto del Garda anche nelle versioni più fresche.",
        },
        {
          n: "05",
          img: "/img/tiramisu.webp",
          title: "Dolci & dessert",
          text: "Il nostro tiramisù nel vasetto e i classici della tradizione, per chiudere in dolcezza.",
        },
        {
          n: "06",
          img: "/img/esterno.webp",
          title: "Eleganza & terrazza",
          text: "Una grande sala con arredi ricercati e lampadari imponenti, tavoli all'aperto e musica dal vivo nelle sere più belle.",
        },
      ],
      chips: ["Tavoli all'aperto", "Piatti vegani", "Musica dal vivo", "Grande sala completa"],
    },
    manifesto: {
      eyebrow: "Il nostro manifesto",
      title: "Tre gesti,\nuna sola tavola",
      items: [
        {
          n: "01",
          title: "L'arte del fuoco",
          text: "Il forno a legna è il cuore che batte della casa: dona a ogni pizza e a ogni piatto un sapore vero, profondo, inconfondibile.",
        },
        {
          n: "02",
          title: "La materia prima",
          text: "Selezioniamo ogni giorno produttori del territorio, dal Garda alla pianura veneta: la qualità si riconosce al primo assaggio.",
        },
        {
          n: "03",
          title: "L'ospitalità",
          text: "Famiglie, coppie e gruppi di amici: accogliere con generosità è il nostro mestiere, la ragione per cui si torna da Gunè.",
        },
      ],
    },
    quote: {
      text: "Non serve andare lontano per trovare un posto speciale: basta fermarsi dove la fiamma è accesa.",
      author: "Ristorante Gunè — Castelnuovo del Garda",
    },
    ctaBand: {
      eyebrow: "Prenotazioni",
      title: "Il tuo tavolo ti aspetta",
      text: "Una cena di famiglia, una ricorrenza, una serata con gli amici: al telefono troviamo insieme il posto giusto per te.",
      orForm: "oppure compila il modulo di prenotazione",
    },
    about: {
      eyebrow: "Chi Siamo",
      titleA: "Una storia di fuoco",
      titleB: "e ospitalità",
      intro:
        "Sulla strada che porta al Lago di Garda, Gunè è un grande salotto dove la cura della bella cucina incontra il calore della tradizione.",
      story: [
        "Gunè nasce da un'idea semplice: unire la cura della grande cucina al piacere genuino della pizza, in un unico luogo elegante ma dal cuore autentico.",
        "La nostra sala ampia e luminosa, con arredi ricercati e lampadari imponenti, accoglie cene di famiglia, ricorrenze e serate di gruppo; d'estate la terrazza si apre all'aperto, tra tavoli sotto le stelle e musica dal vivo.",
        "In cucina due anime si incontrano: il focolare, dove il legno cuoce pizze a lunga maturazione, e la cucina mediterranea di carne e pesce, che celebra i sapori del territorio veneto.",
      ],
      storyImgCaption: "Ogni sera, dal primo tavolo all'ultimo arrivederci",
      craft: {
        eyebrow: "La nostra gente",
        title: "Il gesto del\npizzaiolo",
        text: "Ogni giornata comincia presto: l'impasto viene lavorato a mano, un disco alla volta, e sfornato con la pala dal forno a legna. Un mestiere antico che portiamo avanti con orgoglio, ogni sera, davanti ai nostri ospiti.",
        caption: "Sfornata dopo sfornata, la serata prende forma",
      },
      parallaxCaption: "Via XXV Aprile 80 — la nostra casa a Castelnuovo del Garda",
      philosophy: {
        eyebrow: "La filosofia",
        title: "Cosa crediamo\ndavvero",
        items: [
          {
            n: "01",
            title: "Il tempo del lievito",
            text: "Le nostre pizze nascono da impasti a lunga maturazione: la leggerezza non è un trucco, è pazienza.",
          },
          {
            n: "02",
            title: "La materia prima",
            text: "Produttori locali, pesce fresco, carni selezionate e verdure di stagione: la qualità si riconosce al primo assaggio.",
          },
          {
            n: "03",
            title: "L'ospitalità",
            text: "Servire con generosità e attenzione è il gesto che trasforma una cena in un ricordo.",
          },
        ],
      },
      cta: "Vieni a conoscerci",
    },
    menuPage: {
      eyebrow: "Il Menu",
      titleA: "Scopri il nostro",
      titleB: "Menu",
      intro:
        "Antipasti, pizze dal forno a legna, primi e secondi di carne e pesce, dolci e una selezione di vini: la carta completa è aggiornata stagione dopo stagione.",
      cardTitle: "Scopri il nostro Menu",
      cardText:
        "Apri il menu digitale completo con tutti i piatti, le pizze e i vini del momento.",
      cardCta: "Apri il menu",
      preview: {
        eyebrow: "Dalla nostra carta",
        title: "Cosa troverai",
        items: [
          { title: "Antipasti", text: "Gli stuzzichini e i piatti d'apertura della casa" },
          { title: "Pizze dal Forno a Legna", text: "Classiche e gourmet, cotte a fiamma viva" },
          { title: "Primi & Secondi", text: "Carne e pesce: la mediterranea di Gunè" },
          { title: "Dolci & Vini", text: "Il finale dolce e i vini del Garda" },
        ],
      },
      note: "Il menu si apre in una nuova scheda.",
      wine: {
        eyebrow: "Dolci & Vini",
        text: "Una cantina curata: etichette del territorio e grandi bollicine per accompagnare ogni piatto.",
      },
    },
    contact: {
      eyebrow: "Contatti & Prenotazioni",
      titleA: "Vieni a",
      titleB: "trovarci",
      intro:
        "Siamo sulla strada per il Lago di Garda, a Castelnuovo del Garda: facci click, chiamaci o scrivici — il tuo tavolo è a un gesto di distanza.",
      cards: {
        addressT: "Indirizzo",
        directions: "Indicazioni stradali",
        phoneT: "Telefono",
        callUs: "Chiamaci ora",
        hoursT: "Orari",
        hoursDays: "Tutti i giorni",
        hoursDetail: "12:00 – 14:30 · 18:30 – 23:30",
        ratingT: "Recensioni",
        ratingValue: "4,3 stelle su Google",
        ratingSub: "3.360 recensioni verificate",
        googleProfile: "Profilo Google Business",
      },
      form: {
        eyebrow: "Prenota un tavolo",
        title: "Richiedi la tua prenotazione",
        text: "Compila il modulo: ti richiameremo al più presto per confermare il tuo tavolo.",
        name: "Nome e cognome",
        namePh: "Il tuo nome",
        phone: "Telefono",
        phonePh: "+39 ...",
        date: "Data",
        time: "Ora",
        guests: "Ospiti",
        notes: "Note (allergie, occasioni speciali…)",
        notesPh: "Scrivici se hai richieste particolari",
        submit: "Invia richiesta",
        sending: "Invio…",
        success: "Richiesta inviata! Ti contatteremo per confermare la prenotazione.",
        error: "Si è verificato un errore. Chiama lo +39 045 640 2529.",
        missing: "Compila nome, telefono e data.",
        guestsLabel: "persone",
      },
      mapTitle: "Come raggiungerci",
      follow: "Seguici",
      socials: {
        instagram: "Instagram",
        facebook: "Facebook",
        google: "Google Business",
        tripadvisor: "TripAdvisor",
        website: "Sito ufficiale",
      },
    },
    footer: {
      tagline: "Ristorante & Pizzeria a Castelnuovo del Garda, sulla strada del Lago di Garda.",
      explore: "Esplora",
      contacts: "Contatti",
      hoursT: "Orari",
      hoursV: "Tutti i giorni · 12:00–14:30 / 18:30–23:30",
      rights: "Tutti i diritti riservati.",
      credit: "Sito realizzato da",
      legal: {
        privacy: "Privacy Policy",
        terms: "Termini e Condizioni",
        cookies: "Cookie Policy",
      },
    },
  },
  en: {
    floating: "Call & book",
    nav: {
      home: "Home",
      about: "About Us",
      menu: "Menu",
      contact: "Contact",
      book: "Book now",
    },
    hero: {
      eyebrow: "Restaurant · Pizzeria · Wood-Fired Oven",
      place: "Castelnuovo del Garda — Lake Garda",
      name: "Gunè",
      tagline: "The art of fire, the soul of the table.",
      sub: "Mediterranean meat and fish cuisine, pizza cooked over a living flame in the grand elegant dining room on the road to Lake Garda.",
      ctaBook: "Book a table",
      ctaMenu: "Discover the menu",
      ratingLine: "4.3 · 3,360 Google reviews",
      scroll: "Scroll",
    },
    marquee: [
      "Wood-Fired Oven",
      "Fine Gastronomy",
      "Castelnuovo del Garda",
      "Wine Selection",
      "Gourmet Pizza",
      "Hospitality",
    ],
    highlights: {
      eyebrow: "Our highlights",
      title: "The pleasure of the table,\nin every detail",
      intro:
        "The reasons our guests keep coming back: a flame that never goes out, local ingredients and a dining room that welcomes.",
      cards: [
        {
          n: "01",
          img: "/img/pizza.webp",
          title: "Gourmet wood-fired pizza",
          text: "Slow-fermented dough, airy crust and carefully chosen ingredients: our pizza is born from a living flame that never goes out.",
        },
        {
          n: "02",
          img: "/img/pesce.webp",
          title: "Mediterranean meat & fish cuisine",
          text: "From Venetian tradition to the flavours of Lake Garda: meat and fish dishes, vegan options and fresh produce every day.",
        },
        {
          n: "03",
          img: "/img/tagliere.webp",
          title: "Antipasti & cold cuts",
          text: "Generous boards of salumi and cheeses, house fritters and bruschette: the best way to start the meal.",
        },
        {
          n: "04",
          img: "/img/insalata.webp",
          title: "Salads & fresh dishes",
          text: "Light, genuine plates with crunchy seasonal ingredients: the taste of Lake Garda in its freshest form.",
        },
        {
          n: "05",
          img: "/img/tiramisu.webp",
          title: "Desserts",
          text: "Our tiramisù served in a jar and the classics of tradition, for a sweet ending.",
        },
        {
          n: "06",
          img: "/img/esterno.webp",
          title: "Elegance & terrace",
          text: "A grand dining room with refined furnishings and striking chandeliers, outdoor tables and live music on the finest evenings.",
        },
      ],
      chips: ["Outdoor tables", "Vegan dishes", "Live music", "Large dining room"],
    },
    manifesto: {
      eyebrow: "Our manifesto",
      title: "Three gestures,\none table",
      items: [
        {
          n: "01",
          title: "The art of fire",
          text: "The wood-fired oven is the beating heart of the house: it gives every pizza and every dish a true, deep, unmistakable flavour.",
        },
        {
          n: "02",
          title: "The ingredients",
          text: "Every day we select local producers, from Lake Garda to the Veneto plain: quality is recognised at first taste.",
        },
        {
          n: "03",
          title: "Hospitality",
          text: "Families, couples and groups of friends: welcoming with generosity is our craft, the reason people come back to Gunè.",
        },
      ],
    },
    quote: {
      text: "You don't need to travel far to find somewhere special: just stop where the flame is burning.",
      author: "Ristorante Gunè — Castelnuovo del Garda",
    },
    ctaBand: {
      eyebrow: "Reservations",
      title: "Your table is waiting",
      text: "A family dinner, a celebration, an evening with friends: on the phone we'll find the right spot for you together.",
      orForm: "or fill in the booking form",
    },
    about: {
      eyebrow: "About Us",
      titleA: "A story of fire",
      titleB: "and hospitality",
      intro:
        "On the road that leads to Lake Garda, Gunè is a grand dining room where the care of fine cuisine meets the warmth of tradition.",
      story: [
        "Gunè was born from a simple idea: to bring together the care of great cuisine and the genuine pleasure of pizza, in a single place that is elegant yet authentic at heart.",
        "Our large, bright dining room, with refined furnishings and striking chandeliers, welcomes family dinners, celebrations and group evenings; in summer the terrace opens outdoors, with tables under the stars and live music.",
        "In the kitchen two souls meet: the wood-fired hearth, where the wood bakes slow-fermented pizzas, and the Mediterranean cuisine of meat and fish, celebrating the flavours of the Veneto region.",
      ],
      storyImgCaption: "Every evening, from the first table to the last farewell",
      craft: {
        eyebrow: "Our people",
        title: "The pizzaiolo's\ngesture",
        text: "Every day starts early: the dough is shaped by hand, one disc at a time, and pulled from the wood-fired oven with the peel. An ancient craft we carry on with pride, every evening, in front of our guests.",
        caption: "One pizza after another, the evening takes shape",
      },
      parallaxCaption: "Via XXV Aprile 80 — our home in Castelnuovo del Garda",
      philosophy: {
        eyebrow: "Our philosophy",
        title: "What we truly\nbelieve in",
        items: [
          {
            n: "01",
            title: "The time of dough",
            text: "Our pizzas come from slow-fermented doughs: lightness is not a trick, it is patience.",
          },
          {
            n: "02",
            title: "The ingredients",
            text: "Local producers, fresh fish, selected meats and seasonal vegetables: quality is recognised at first taste.",
          },
          {
            n: "03",
            title: "Hospitality",
            text: "Serving with generosity and care is the gesture that turns a dinner into a memory.",
          },
        ],
      },
      cta: "Come and meet us",
    },
    menuPage: {
      eyebrow: "The Menu",
      titleA: "Discover our",
      titleB: "Menu",
      intro:
        "Appetisers, wood-fired pizzas, meat and fish courses, desserts and a selection of wines: the full menu is updated season after season.",
      cardTitle: "Discover our Menu",
      cardText: "Open the complete digital menu with all our dishes, pizzas and wines.",
      cardCta: "Open the menu",
      preview: {
        eyebrow: "From our menu",
        title: "What you will find",
        items: [
          { title: "Appetisers", text: "The house bites and opening dishes" },
          { title: "Wood-Fired Pizzas", text: "Classic and gourmet, cooked over a living flame" },
          { title: "First & Main Courses", text: "Meat and fish: the Gunè Mediterranean" },
          { title: "Desserts & Wines", text: "A sweet finale and the wines of Lake Garda" },
        ],
      },
      note: "The menu opens in a new tab.",
      wine: {
        eyebrow: "Desserts & Wines",
        text: "A carefully kept cellar: local labels and great sparkling wines to accompany every dish.",
      },
    },
    contact: {
      eyebrow: "Contact & Reservations",
      titleA: "Come and",
      titleB: "visit us",
      intro:
        "We are on the road to Lake Garda, in Castelnuovo del Garda: click, call or write to us — your table is one gesture away.",
      cards: {
        addressT: "Address",
        directions: "Get directions",
        phoneT: "Phone",
        callUs: "Call us now",
        hoursT: "Opening hours",
        hoursDays: "Every day",
        hoursDetail: "12:00 – 14:30 · 18:30 – 23:30",
        ratingT: "Reviews",
        ratingValue: "4.3 stars on Google",
        ratingSub: "3,360 verified reviews",
        googleProfile: "Google Business profile",
      },
      form: {
        eyebrow: "Book a table",
        title: "Request your reservation",
        text: "Fill in the form: we will call you back as soon as possible to confirm your table.",
        name: "Full name",
        namePh: "Your name",
        phone: "Phone",
        phonePh: "+39 ...",
        date: "Date",
        time: "Time",
        guests: "Guests",
        notes: "Notes (allergies, special occasions…)",
        notesPh: "Let us know about special requests",
        submit: "Send request",
        sending: "Sending…",
        success: "Request sent! We will contact you to confirm your booking.",
        error: "Something went wrong. Please call +39 045 640 2529.",
        missing: "Please fill in name, phone and date.",
        guestsLabel: "guests",
      },
      mapTitle: "How to reach us",
      follow: "Follow us",
      socials: {
        instagram: "Instagram",
        facebook: "Facebook",
        google: "Google Business",
        tripadvisor: "TripAdvisor",
        website: "Official website",
      },
    },
    footer: {
      tagline: "Restaurant & Pizzeria in Castelnuovo del Garda, on the road to Lake Garda.",
      explore: "Explore",
      contacts: "Contact",
      hoursT: "Opening hours",
      hoursV: "Every day · 12:00–14:30 / 18:30–23:30",
      rights: "All rights reserved.",
      credit: "Website by",
      legal: {
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
        cookies: "Cookie Policy",
      },
    },
  },
};
